<template>
  <div>
    <h2>ログイン</h2>
    <form @submit.prevent="handleLogin">
      <input v-model="name" type="text" placeholder="名前" required />
      <input v-model="password" type="password" placeholder="パスワード" required />
      <button type="submit">ログイン</button>
    </form>
    <p v-if="message">{{ message }}</p>
    <p>アカウントをお持ちでないですか？ <router-link to="/signup">サインアップ</router-link></p>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import { useStore } from 'vuex'; // Vuexストアをインポート

export default {
  name: 'UserLogin',
  setup() {
    const router = useRouter();
    const store = useStore(); // ストアを使用
    const name = ref('');
    const password = ref('');
    const message = ref('');

    const handleLogin = async () => {
      try {
        const response = await fetch('http://172.16.80.71:5000/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: name.value,
            password: password.value,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          message.value = data.message; // ログイン成功メッセージ
          store.dispatch('login', name.value); // Vuexストアでログイン処理を呼び出す
          router.push('/productlist'); // 成功時に /productlist にリダイレクト
        } else {
          message.value = data.message; // エラーメッセージ
        }
      } catch (error) {
        message.value = 'エラーが発生しました'; // ネットワークエラーなど
      }
    };

    return {
      name,
      password,
      message,
      handleLogin,
    };
  },
};
</script>

<style>
/* 必要に応じてスタイルを追加 */
</style>